module.exports = __webpack_public_path__ + "img/img-a87fd4dc.04638009.png";